import { ResourceHelperService } from "../resource-helper.service";

/**
 * A dataservice that provides CRUD operations on the Organisation Service
 */
export class OrganisationService {
  private organisationResource: InterACT.Interfaces.IResource<InterACT.Interfaces.Organisations.OrganisationResponse>;

  constructor(private $resource: ng.resource.IResourceService, private resourceHelperService: ResourceHelperService) {
    this.organisationResource = $resource('api/organisations/:organisationId', undefined);
  }

  /**
   * Function to retrieve a single organisation record
   *
   * @param organisationId The id of the organisation we wish to receive
   *
   * @returns A Http promise resource object
  */
  public getSingleOrganisation(organisationId: string) {
    return this.organisationResource.get({ organisationId: organisationId }).$promise;
  }
}
